<template>
	<div class="form-base">
		<v-row>
			<v-col cols="12">
				<DadataOrgField
					label="Наименование, указанное в ЕГРЮЛ"
					outlined
					v-model="v.name.$model"
					:errorMessages="getValidationErrorText(v.name)"
					:disabled="disabled"
					:suggestions="suggestions"
					field="name"
					@suggest="onSelect"
					@blur="v.name.$touch"
				/>
			</v-col>

			<v-col cols="4">
				<DadataOrgField
					v-model="v.ogrn.$model"
					:errorMessages="getValidationErrorText(v.ogrn)"
					:disabled="disabled"
					mask="#############"
					label="ОГРН"
					outlined
					:suggestions="suggestions"
					field="ogrn"
					@suggest="onSelect"
					@blur="v.ogrn.$touch"
				/>
			</v-col>
			<v-col cols="4">
				<DadataOrgField
					v-model="v.inn.$model"
					:errorMessages="getValidationErrorText(v.inn)"
					:disabled="disabled"
					mask="##########"
					label="ИНН"
					outlined
					:suggestions="suggestions"
					field="inn"
					@suggest="onSelect"
					@blur="v.inn.$touch"
				/>
			</v-col>
			<v-col cols="4">
				<v-text-field
					v-model="v.kpp.$model"
					:errorMessages="getValidationErrorText(v.kpp)"
					:disabled="disabled"
					v-mask="KPP"
					label="КПП"
					outlined
					@blur="v.kpp.$touch"
				/>
			</v-col>
		</v-row>

		<AddressEGRUL :v="v" :disabled="disabled" notice-recovery :translationKey="translationKey ? `${translationKey}.egrul` : undefined"/>

		<v-row>
			<v-col cols="4">
				<DateFieldCustom
					label="Дата гос. регистрации"
					:value="v.regDate.$model"
					:disabled="disabled"
					:errorMessage="v.regDate"
					:max="new Date().toISOString()"
					@change="v.regDate.$model = $event"
					@blur="v.regDate.$touch"
				/>
			</v-col>
			<v-col cols="4">
				<v-text-field
					v-model="v.email.$model"
					:errorMessages="getValidationErrorText(v.email)"
					:disabled="disabled"
					label="Адрес электронной почты, содержащийся в ЕГРЮЛ"
					outlined
					@blur="v.email.$touch"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import DateFieldCustom from '@/components/base/DateFieldCustom';
import {
	DATE_FORMAT,
	DATE_FUTURE,
	DATE_PAST,
	EMAIL,
	EMOJI,
	getValidationErrorText,
	MAX_LENGTH,
	INN,
	KPP, TRAILING_AND_LEADING_SPACES,
} from '@/utils/validate';
import {and, maxLength, minLength, required} from 'vuelidate/lib/validators';
import AddressEGRUL from '@/components/services/NoticeRecovery/General/AddressEGRUL';
import DadataOrgField from '@/components/base/DadataOrgField';

export const organizationModel = {
	name: '',
	address: {},
	addressesMatch: false,
	factAddress: {},
	ogrn: '',
	regDate: '',
	inn: '',
	kpp: '',
	email: '',
};

export const organizationValidation = {
	name: {
		required,
		maxLength: maxLength(1000),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
	address: {
		required,
		TRAILING_AND_LEADING_SPACES
	},
	addressesMatch: {},
	factAddress: {
		required,
	},
	ogrn: {
		required,
		minLength: minLength(13),
	},
	regDate: {
		required,
		DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
	},
	inn: {
		required,
		minLength: minLength(10),
		INN: INN(10),
	},
	kpp: {
		required,
		minLength: minLength(9),
		KPP,
	},
	email: {
		required,
		EMAIL,
		maxLength: maxLength(MAX_LENGTH),
		TRAILING_AND_LEADING_SPACES
	},
};

export default {
	name: 'Organization',
	props: {
		v: Object,
		disabled: Boolean,
		translationKey: String,
	},
	components: {
		AddressEGRUL,
		DateFieldCustom,
		DadataOrgField,
	},
	data: () => ({
		suggestions: [],
		getValidationErrorText,
	}),
	methods: {
		onSelect: function (item) {
			this.suggestions = [item];
			this.v.name.$model = item.name;
			this.v.inn.$model = item.inn;
			this.v.ogrn.$model = item.ogrn;
			this.v.kpp.$model = item.kpp;

			this.v.regDate.$model = item.regDate;
			this.v.email.$model = item.email;
			this.v.address.$model = {...item.address};
			this.v.addressesMatch.$model = true;
		}
	},
};
</script>

<style scoped></style>
